import {match} from 'ts-pattern';

import {isNotNil} from 'ramda';

import type {DataGridRow} from '@dms/api/core';

import {DATA_GRID_KEY_VALUE_SCHEMA, readDataGridCell} from './readDataGridCell';

export function readDataGridCellKeyLabel(row: DataGridRow, keys: readonly string[]) {
  const result = DATA_GRID_KEY_VALUE_SCHEMA.safeParse(readDataGridCell(row, keys));

  return match(result)
    .with({success: false}, () => undefined)
    .with({success: true}, ({data}) => ({
      value: data.key,
      ...(isNotNil(data.label) ? {label: data.label} : {}),
    }))
    .exhaustive();
}
